import { Input } from '@material-tailwind/react'
import Select from 'react-tailwindcss-select'

import LoadingButton from '@/Shared/LoadingButton'
import DeleteButton from '@/Shared/DeleteButton'

const Designations = [
  {
    label: 'Supervisor',
    value: 'Supervisor'
  },
  {
    label: 'Janitors',
    value: 'Janitors'
  },
  {
    label: 'Sewermen',
    value: 'Sewermen'
  }
]

export default function ({
  handleSubmit,
  errors,
  data,
  setData,
  processing,
  isDeleted,
  destroy,
  avatar,
  isEdit = false
}) {
  return (
    <div className="flex w-full flex-row gap-x-2">
      <div style={{ width: '65%' }} className="rounded bg-white p-8 shadow">
        <h1 className="text-2xl font-semibold">HR Designation Form</h1>

        <form name="createForm" onSubmit={handleSubmit} className="mt-8">
          <div className="flex flex-col gap-4 md:flex-row">
            <Input
              size="lg"
              label="Name"
              name="name"
              error={errors.name}
              value={data.name}
              onChange={e => setData('name', e.target.value)}
            />

            <Input
              size="lg"
              label="Contact"
              name="contact"
              type="number"
              error={errors.contact}
              value={data.contact}
              onChange={e => setData('contact', e.target.value)}
            />
          </div>

          <div className="mt-6 flex flex-col gap-4 md:flex-row">
            <Input
              size="lg"
              label="CNIC"
              name="cnic"
              type="number"
              error={errors.cnic}
              value={data.cnic}
              onChange={e => setData('cnic', e.target.value)}
            />

            <Select
              label="Select Hospital"
              name="designation"
              error={errors.designation}
              primaryColor="indigo"
              value={
                data.designation &&
                Designations.find(({ value }) => value === data.designation)
              }
              options={Designations}
              onChange={option => setData('designation', option.value)}
            />
          </div>

          <div className="mt-6 flex flex-col gap-4 md:flex-row">
            <Input
              size="lg"
              label="Profile Image"
              name="avatar"
              type="file"
              accept="image/*"
              error={errors.avatar}
              onChange={e => setData('avatar', e.target.files[0])}
            />
          </div>

          <div className="mt-8 flex items-center justify-between border-t border-gray-200 bg-gray-100 px-8 py-4">
            {isEdit && !isDeleted && (
              <DeleteButton onDelete={destroy}>Delete Entry</DeleteButton>
            )}

            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-indigo"
            >
              {isEdit ? 'Edit' : 'Add'} HR Designation
            </LoadingButton>
          </div>
        </form>
      </div>

      {isEdit && (
        <div style={{ width: '35%' }}>
          <img
            className="w-full object-contain object-center"
            src={avatar}
            style={{ maxHeight: '24rem' }}
            alt={data.name}
          />
        </div>
      )}
    </div>
  )
}
